import styled from 'styled-components';
import { parseColor } from '../../styles';
import { Flex } from '../Core';
import { Text } from '../Text';

export const CardWrapper = styled(Flex)`
  flex-direction: column;
  background: ${({ theme, background }) =>
    background ? (typeof background === 'number' ? background : parseColor(theme, background)) : theme.backgroundCard};
`;
CardWrapper.defaultProps = {
  p: 'spacing12',
};

export const Header = styled(Flex)`
  border-bottom: 1px solid ${({ theme }) => theme.backgroundBody};
`;
Header.defaultProps = {
  mx: '-spacing12',
  px: 'spacing12',
  pb: 'spacing12',
  mb: 'spacing12',
  justifyContent: 'space-between',
  alignItems: 'center',
  h: 28,
};

export const Title = styled.span`
  color: ${({ theme }) => theme.colorTextImportant};
`;

export const Subtitle = styled(Text)`
  text-transform: uppercase;
  font-weight: 500;
`;
Subtitle.defaultProps = {
  color: 'colorTextSubtle',
  size: 'fontSizeSmall',
  mb: 'spacing12',
  display: 'block',
};

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing4}px;
`;
